<template lang="pug">

form.ui.form(v-on:submit.prevent="submit()")

    //- Navigation
    navigation

    //- Formular
    .ui.top.attached.header Allgemeine Informationen:
    update-form(
        ref="form"
        v-bind:segment="'ui bottom attached segment'"
        v-bind:purchaser-models="purchaserModels"
        v-model="mutable"
    )

    //- Actions
    action-row.ui.bottom.secondary(v-on:cancel='cancel()')

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import ActionRow from '@/components/form/ActionRow'
    import UpdateForm from '@/components/campaigns/UpdateForm'
    import Navigation from '@/components/products/Navigation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {
        name: 'campaign-update-view',

        components: { ActionRow, Navigation, UpdateForm },

        beforeRouteEnter(to, from, next) {
            Promise.all([

                // Kampagne laden
                store.dispatch('campaigns/loadOne', { id: to.params.id })

                    // Benutzer und Personen des Unternehmens laden
                    .then(campaignModel => Promise.all([
                        store.dispatch('users/loadAllByCompanyId', { companyId: campaignModel.company }),
                        store.dispatch('persons/loadAllByCompanyId', { companyId: campaignModel.company })
                    ])),

                // Alle Auftraggeber laden
                store.dispatch('companies/loadAllByIsPurchaser'),

            ]).then(() => next(vm => {
                vm.mutable = R.clone(store.getters['campaigns/byId'](to.params.id))
            }))
        },

        async beforeRouteUpdate(to, from, next) {
            await Promise.all([

                // Kampagne laden
                store.dispatch('campaigns/loadOne', { id: to.params.id, force: true })

                    // Benutzer und Personen des Unternehmens laden
                    .then(campaignModel => Promise.all([
                        store.dispatch('users/loadAllByCompanyId', { companyId: campaignModel.company }),
                        store.dispatch('persons/loadAllByCompanyId', { companyId: campaignModel.company })
                    ])),

                // Alle Auftraggeber laden
                store.dispatch('companies/loadAllByIsPurchaser'),

            ])

            this.mutable = R.clone(store.getters['campaigns/byId'](to.params.id))
            next()
        },

        computed: {

            purchaserModels() {
                return store.getters['companies/allByIsPurchaser']
            },

        },

        created() {
            this.mutable = R.clone(store.getters['campaigns/byId'](this.$route.params.id))
        },

        data() {
            return { mutable: {} }
        },

        methods: {

            cancel() {
                this.$router.push({ name: 'campaigns' })
            },

            persist() {
                this.$refs.form.persist()

                    // Growl anzeigen
                    .then(() => this.$growl.success('Kampagne wurde aktualisiert'))

                    // Zur Übersicht weiterleiten
                    .then(() => this.$router.push({ name: 'campaigns' }))

                    // Fehlermeldung anzeigen
                    .catch(e => this.$growl.fatal('Kampagne konnte nicht gespeichert werden', e))
            },

            submit() {
                this.$refs.form.validate().then(R.when(R.equals(true), this.persist))
            }

        }

    }

</script>
